// hooks/useDealerInventoryUpload.js
import { useState, useEffect } from "react";
import useSWR from "swr";
import useDealerId from "./useDealerId";
import useDealerInventoryLog from "./useDealerInventoryLog";
import DealerInventoryUploadService from "services/DealerInventoryUploadService";
import VehicleService from "services/VehicleService"; // aquí está getMakes

export default function useDealerInventoryUpload() {
    const dealerId = useDealerId();
    const catalog = "motor";
    const region = "us";

    const { data: makes = [] } = useSWR(
        dealerId ? ["dealer-makes", dealerId, catalog, region] : null,
        () =>
            VehicleService.getMakes({
                dlid: dealerId,
                catalog,
                region,
            }),
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            dedupingInterval: 30000,
        }
    );

    const [isUploading, setIsUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showSuccess, setShowSuccess] = useState(false);
    const { log = [], refresh } = useDealerInventoryLog();

    useEffect(() => {
        let timer;
        if (isUploading) {
            timer = setInterval(() => {
                setProgress((prev) => {
                    if (prev < 85) return prev + 1;
                    if (prev < 98) return +(prev + 0.25).toFixed(2);
                    return prev;
                });
            }, 100);
        }
        return () => clearInterval(timer);
    }, [isUploading]);

    const handleUpload = (slug, file) => {
        if (!file || !dealerId || !slug) {
            console.warn("Missing file, dealerId or make_slug");
            return;
        }

        setIsUploading(true);
        setShowSuccess(false);
        setProgress(0);
        const start = Date.now();

        DealerInventoryUploadService.upload({
            file,
            dealer_id: dealerId,
            make_slug: slug,
        })
            .then(() => {
                const elapsed = Date.now() - start;
                const remaining = 10000 - elapsed;
                setTimeout(
                    () => {
                        setProgress(100);
                        setIsUploading(false);
                        setShowSuccess(true);
                        refresh();
                    },
                    remaining > 0 ? remaining : 0
                );
            })
            .catch((err) => {
                console.error("Upload failed:", err);
                setIsUploading(false);
                alert("An error occurred while processing the file.");
            });
    };

    return {
        dealerId,
        makes,
        isUploading,
        progress,
        showSuccess,
        setShowSuccess,
        handleUpload,
        log,
    };
}
